import enLang from "./entries/en-US";
import ruLang from "./entries/ru-RU";

const AppLocale = {
  en: enLang,
  ru: ruLang,
};

export default AppLocale;
